import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1c7d63eb&scoped=true&"
var script = {}
import style0 from "./Register.vue?vue&type=style&index=0&id=1c7d63eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d63eb",
  null
  
)

component.options.__file = "Register.vue"
export default component.exports